export default __webpack_public_path__ + "static/media/messaging.70aa4c82.svg";